module.exports = __webpack_public_path__ + "img/ar-qtv-1.afc2a3e5.webp";